function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Nav, Item } from './elements';
/**
 * A Navigation wraps all the logic between navigation items,
 * usually you should pass link as child but Navigation accept all tag's type.
 *
 * @return {jsx}
 */

var Navigation = function Navigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isFluid = _ref.isFluid,
      isVertical = _ref.isVertical;
  return /*#__PURE__*/React.createElement(Nav, {
    className: className,
    isVertical: isVertical,
    "data-testid": "navigation"
  }, Children.map(children, function (_ref2, index) {
    var _ref2$props = _ref2.props,
        isActive = _ref2$props.isActive,
        props = _objectWithoutProperties(_ref2$props, ["isActive"]),
        type = _ref2.type;

    return /*#__PURE__*/React.createElement(Item, _extends({
      isFluid: isFluid,
      isVertical: isVertical,
      key: index,
      as: type,
      isActive: isActive
    }, props), props.children);
  }));
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    bool = PropTypes.bool,
    string = PropTypes.string;
Navigation.propTypes = {
  /** Usually you should pass link as child but Navigation accept all tag's type. */
  children: node,

  /** ClassName needed by styled components */
  className: string,

  /** Does items take all remaining space or not. */
  isFluid: bool,

  /** Does items are rendered in vertical or horizontal display. */
  isVertical: bool
};
/**
 * Default props.
 */

Navigation.defaultProps = {
  children: null,
  className: '',
  isFluid: false,
  isVertical: false
};
export default Navigation;